import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'react-bootstrap';
import { OpenInNew } from '@material-ui/icons';
import Link from '@material-ui/core/Link';

const styles = {
  closeButton: {
    borderRadius: '50%',
    border: 'none',
    padding: '5px',
    cursor: 'pointer',
    backgroundColor: '#F6F6F6'
  },
  closeIcon: {
    width: '24px',
    height: '24px'
  },
  header: {
    textAlign: 'right',
    padding: '16px'
  },
  dialogContent: {
    maxWidth: '333px',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
    lineHeight: '32px'
  },
  supportLink: {
    verticalAlign: 'middle'
  },
  supportIcon: {
    verticalAlign: 'middle',
    marginLeft: '5px'
  }
};

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  }
});

const Main = enhance(
  ({ openHelpGochiKid, setOpenHelpGochiKid, isSmall, classes }) => {
    const classesD = useStyles();
    return (
      <Dialog
        open={openHelpGochiKid}
        onClose={() => {
          setOpenHelpGochiKid(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classesD.paperWidthSm
        }}
      >
        <div className={classes.header}>
          <Button
            className={classes.closeButton}
            onClick={() => {
              setOpenHelpGochiKid(false);
            }}
          >
            <CloseIcon className={classes.closeIcon} color="primary" />
          </Button>
        </div>
        <DialogContent
          style={{
            padding: '0px 16px 36px 16px'
          }}
        >
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogContent}
          >
            地域のお店を起点にこどもの居場所をつくり、まちの未来を育むこども食堂サービスです。
            <br />
            <br />
            GOCHIプラットフォームに登録している店舗さまは、企業や個人からの寄付や支援金を原資にこども食堂を運営することができます。
            <br />
            普段から提供しているメニューをこども食堂メニューとして設定することで、こども食堂として利用いただくことが可能となります。
            <div style={{ marginTop: '8px' }}>
              <Link
                href="https://kids-future-passport.org"
                target="_blank"
                className={classes.supportLink}
              >
                こどもごちめし
                <OpenInNew color="primary" className={classes.supportIcon} />
              </Link>
            </div>
            <div style={{ marginTop: '16px' }}>
              <Link
                href="https://shop-guide.gochimeshi.com/kodomogochimeshi/"
                target="_blank"
                className={classes.supportLink}
              >
                マニュアルURL
                <OpenInNew color="primary" className={classes.supportIcon} />
              </Link>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
